/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from "react";
import { ChevronsUpDown, LoaderCircle, Search } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Command,
  CommandGroup,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { ConditionRenderer } from "@/components/shared/condition-renderer";
import { Input } from "@/components/ui/input";
import { InViewComponent } from "@/components/shared/in-view-component";

type ErpSkuProp = {
  placeholder: string;
  isPending: boolean;
  value: string;
  emptyListMessage?: string;
  searchLabel?: string;
  onChange: (prop: string) => void;
  onSearch: (prop: string) => Promise<void>;
  onBlur: () => void;
};

export const ItemMasterMapping = ({
  placeholder,
  searchLabel,
  emptyListMessage,
  value,
  onChange,
  onSearch,
  onBlur,
  isPending,
}: ErpSkuProp) => {
  const [searchText, setSearchText] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [process, setProcess] = React.useState(false);
  const [list, setList] = React.useState<any>([]);

  const onChangeValue = (prop: string) => {
    onChange(prop);
  };

  React.useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (searchText === "") {
        setList([]);
        setProcess(false);
        return;
      }
      setList([]);
      setProcess(true);
      try {
        const response: any = await onSearch(searchText);
        if (response?.data) {
          setList(response.data);
        }
      } finally {
        setProcess(false);
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchText]);

  // const isCurrentOptionIsFiltered = (label: string) => {
  //   const localLabel = label.toLowerCase();
  //   const localSearchText = searchText.toLowerCase();

  //   return localLabel.includes(localSearchText) || false;
  // };

  // const displayOptionsLabel = ({ erp_sku_code }: { erp_sku_code: string }) => {
  //   return `<span>${erp_sku_code}</span>
  //     `;
  // };

  return (
    <>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild onBlur={onBlur}>
          <Button
            variant="outline"
            role="combobox"
            aria-expanded={open}
            className="w-full justify-between "
          >
            <span className="flex-1 truncate text-left">
              {value || placeholder || "Select Options..."}
            </span>
            {isPending ? (
              <LoaderCircle className="animate-spin" />
            ) : (
              <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-[400px] p-0" align="end">
          <Command>
            <div className="p-1">
              <div className="flex">
                <Button className="absolute" size={"icon"} variant={"ghost"}>
                  <Search />
                </Button>
                <Input
                  className="!outline-none !border-none pl-10 focus:ring-0 focus:ring-offset-0"
                  onChange={(e) => setSearchText(e.target.value)}
                  value={searchText}
                  placeholder={searchLabel || "Search Options"}
                />
              </div>
            </div>

            <CommandList>
              <ConditionRenderer condition={list.length === 0}>
                <ConditionRenderer condition={process}>
                  <div className="flex items-center justify-center">
                    <LoaderCircle className="mr-2 h-6 w-6 animate-spin" />
                  </div>
                  <div className="text-sm px-3 pt-3">
                    {emptyListMessage || "No Options found."}
                  </div>
                </ConditionRenderer>
              </ConditionRenderer>
              <CommandGroup>
                <InViewComponent list={list} pageSize={100}>
                  {(option: any, index) => {
                    // const label = displayOptionsLabel(option);
                    // const isCurrentItemExist = isCurrentOptionIsFiltered(label);
                    // if (!isCurrentItemExist) {
                    //   return null;
                    // }
                    return (
                      <CommandItem
                        className="text-sm"
                        key={index}
                        value={option}
                        onSelect={() => {
                          // onChangeValue(option.erp_sku_code);
                          onChangeValue(option);
                          setOpen(false);
                        }}
                      >
                        <span
                          data-index={index}
                          className="flex flex-col text-left items-start hover-bg-white"
                        >
                          {option?.erp_sku_name
                            ? option?.erp_sku_name + " / "
                            : null}
                          {option.erp_sku_code}
                          {option?.erp_uom ? ` / ${option?.erp_uom}` : null}
                        </span>
                      </CommandItem>
                    );
                  }}
                </InViewComponent>
                {/* {list.map((option: any, index: number) => {
                  const label = displayOptionsLabel(option);
                  const isCurrentItemExist = isCurrentOptionIsFiltered(label);
                  if (!isCurrentItemExist) {
                    return null;
                  }
                  return (
                    <CommandItem
                      className="text-sm"
                      key={index}
                      value={option}
                      onSelect={() => {
                        onChangeValue(option.erp_sku_code);
                        setOpen(false);
                      }}
                    >
                      <span className="flex flex-col text-left items-start hover-bg-white">
                        {option?.erp_sku_name
                          ? option?.erp_sku_name + " / "
                          : null}
                        {option.erp_sku_code}
                      </span>
                    </CommandItem>
                  );
                })} */}
              </CommandGroup>
            </CommandList>
          </Command>
        </PopoverContent>
      </Popover>
    </>
  );
};
